export default "__VITE_ASSET__CKa3210E__"